import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMyBetsService, getTopBetsService, placeBetSpaceDiceGameService } from '../services/spaceDiceGame.service'

export const placedBetSpaceDiceGame = createAsyncThunk('space-dice-game/place-bet-dice-game',
  async ({ payload }, thunkApi) => {
    try {
      const res = await placeBetSpaceDiceGameService(payload)
      if (res) {
        payload?.onSuccess()
      }
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  })

export const getTopBetsSpaceDiceGame = createAsyncThunk('space-dice-game/topBets',
  async (_, thunkApi) => {
    try {
      const res = await getTopBetsService()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  })

export const getMyBetsSpaceDiceGame = createAsyncThunk('space-dice-game/myBets',
  async (data, thunkApi) => {
    try {
      const res = await getMyBetsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  })
